import { Component } from '@angular/core';
import { CourseService } from '../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-file-name',
  templateUrl: './add-file-name.component.html',
  styleUrls: ['./add-file-name.component.css']
})
export class AddFileNameComponent {
  fileName: any;

  constructor(private readonly courseService: CourseService, private readonly toastr: ToastrService) { }


  addFileName() {
    this.courseService.addFileName({ "filename": this.fileName }).subscribe({
      next: data => {
        this.toastr.success('Filename was added successfully.', 'Success!');
        this.fileName = '';
      },
      error: error => {
        this.toastr.error('Filename could not be added. Please try again later.', 'Error!');
      }
    })
  }
}
